import React, { useEffect } from "react";
import ReportTab from "./ReportTab";
import ReportDetails from "./ReportDetails";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";

const EmotionalRange = (props: any) => {
    const scoreDescription = {
        High: ["Emotionally Reactive", "Anxious", "Temperamental", "Susceptible to Stress", "Perfectionist"],
        Moderate: ["Realist", "Can control emotions under normal stress levels", "Slight mood fluctuations", "Helpful", "Level-Headed"],
        Low: ["Calm", "Poised", "Relaxed", "Handles Stress Well", "Resilient"],
    };
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id={"title-page-" + props.name} tabIndex={-1}>
                        RepIQ™ Reputation Analyzer Report
                    </h1>
                </div>
            </div>

            <ReportTab selectedTab="3" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Emotional Range</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <p>
                                        Emotional Range measures someone's tendency to experience negative emotions. Individuals who score high in Emotional Range
                                        are more susceptible to stress. They may frequently worry, feel anxious, and experience drastic shifts in mood.
                                    </p>
                                    <p>
                                        Individuals who score low in Emotional Range are highly resilient under stressful situations. They tend to be calm, relaxed,
                                        and maintain the ability to think clearly in pressured situations.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div role="option" className="img-container">
                                        <img
                                            src="images/img-emotional-range.jpg"
                                            alt="Woman holding a mask surrounded by other masks portraying various emotions."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReportDetails title={"Emotional Range"} name={"EmotionalRange"} scoreDescription={scoreDescription} />
                </div>
            </div>
        </React.Fragment>
    );
};
export default EmotionalRange;
